function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import { stylePropTypes } from '@dkrm/general-libs/theme/styles';
import { ButtonWrapper as Button } from '@dkrm/ui-kit-basic/v2/Button';
import Text from '@dkrm/ui-kit-basic/Text';
import { BUTTON_TYPE, BUTTON_THEME } from '../constants';
import { getStyleTheme, styles } from './styles';
const ButtonWithText = ({
  theme,
  themeType,
  title,
  small,
  buttonStyle,
  textStyle,
  ...rest
}) => {
  const buttonContainerStyle = [];
  const buttonTextStyle = [];
  return /*#__PURE__*/React.createElement(Button, _extends({
    small: small
  }, rest), state => {
    const styleTheme = getStyleTheme(theme, themeType, state);
    buttonContainerStyle.push(styleTheme.buttonContainer);
    buttonTextStyle.push(styleTheme.buttonText);
    if (small) {
      buttonContainerStyle.push(styles.buttonContainerSmall);
      buttonTextStyle.push(styles.buttonTextSmall);
    } else {
      buttonContainerStyle.push(styles.buttonContainerNormal);
      buttonTextStyle.push(styles.buttonTextNormal);
    }
    buttonContainerStyle.push(buttonStyle);
    buttonTextStyle.push(textStyle);
    return /*#__PURE__*/React.createElement(View, {
      style: buttonContainerStyle
    }, /*#__PURE__*/React.createElement(Text, {
      style: buttonTextStyle
    }, title));
  });
};
ButtonWithText.displayName = "ButtonWithText";
ButtonWithText.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(Object.values(BUTTON_THEME)),
  themeType: PropTypes.oneOf([BUTTON_TYPE.PRIMARY, BUTTON_TYPE.SECONDARY, BUTTON_TYPE.TERTIARY]),
  small: PropTypes.bool,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  buttonStyle: stylePropTypes,
  textStyle: stylePropTypes
} : {};
ButtonWithText.defaultProps = {
  theme: BUTTON_THEME.TOSCA,
  themeType: BUTTON_TYPE.PRIMARY,
  small: false,
  disabled: false,
  selected: false,
  buttonStyle: null,
  textStyle: null
};
ButtonWithText.themes = BUTTON_THEME;
ButtonWithText.types = BUTTON_TYPE;
export default ButtonWithText;